import { useState, useEffect } from "react";
import "./QuestionSettingsNPS.css";
import { QuestionSelector } from "../question-selector/QuestionSelector";
import { Question, QuestionType, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import toast from "react-hot-toast";
import { toastFail } from "../../config";
import { MySwitch } from "../form-widgets/MySwitch";

type QuestionSettingsNPSProps = {
    question: Question;
    onChange: (question: Question) => void;
}

export const QuestionSettingsNPS = ({question, onChange} : QuestionSettingsNPSProps) => {

    const [settings, setSettings] = useState<any | null>(JSON.parse(question.settings));
    const [type, setType] = useState<QuestionType>(question.type);
    const [required, setRequired] = useState<boolean>(question.required);

    useEffect(() => {
        setSettings(JSON.parse(question.settings));
        setRequired(question.required);
        setType(question.type);
    }, [question]);

    const handleTypeChange = async (value: string) => {
        console.log("[QuestionSettingsNPS/handleTypeChange] value: ", value);
    }

    const handleRequiredChange = async (checked: boolean) => {
        setRequired(checked);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required: checked,
            settings: JSON.stringify(settings),
            conditions: question.conditions
        }

        updateSettings(payload);
    }

    // const handleSettingChange = async (e: any) => {
    //     console.log("[QuestionSettingsNPS/handleSettingChange] e: ", e);

    //     let newSettings = {...settings};

    //     switch (e.target.name) {
    //         default:
    //             newSettings = {...settings, [e.target.name]: e.target.value};
    //     }

    //     setSettings(newSettings);

    //     const payload: UpdateQuestionPayload = {
    //         questionId: question.id,
    //         type,
    //         title: question.title,
    //         description: question.description,
    //         required,
    //         settings: JSON.stringify(newSettings),
    //         conditions: question.conditions
    //     }

    //     updateSettings(payload)
    // }

    // have to send in the payload here due to react setting asyncs
    const updateSettings = async(payload: UpdateQuestionPayload) => {

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error updating question", toastFail);
            return;
        }

        // update UI
        onChange(newQuestion);
    }

    // console.log("[QuestionSettingsNPS] settings: ", settings);

    return (        
        <>
            <div className="question-settings-nps">
                {/* <QuestionSelector defaultValue={type} onChange={handleTypeChange}/>

                <div className="question-setting-divider">{}</div> */}

                <div className="question-setting">
                    <div className="question-setting-label">
                        Required
                    </div>
                    <div className="question-setting-checkbox">
                        <MySwitch 
                            id="required"
                            checked={required}
                            onChange={handleRequiredChange}
                        />
                    </div>
                </div>

            </div>
            
        </>
    )
}